<template>

  <section class="dp-layout">
    <!-- 
    <section class="dp-left" :style="{
      display: this.$store.state.HasChildrenDepartment ? 'block' : 'none',
    }"> -->
    <section class="dp-left">
      <div class="dept-scope-bar">
        <button
          type="button"
          class="dept-scope-btn"
          :class="{ 'is-active': deptDirectoryScope === 'teaching' }"
          @click="setDeptDirectoryScope('teaching')">
          家校通讯录
        </button>
        <button
          type="button"
          class="dept-scope-btn"
          :class="{ 'is-active': deptDirectoryScope === 'internal' }"
          @click="setDeptDirectoryScope('internal')">
          内部通讯录
        </button>
      </div>
      <DepartmentPane
        :key="deptDirectoryScope"
        :directory-scope="deptDirectoryScope"
        :pane-title="deptDirectoryScope === 'internal' ? '内部通讯录' : '家校通讯录'"
        :default-select-root="true"
        @tree-node-click="treeNodeClick">
      </DepartmentPane>
    </section>

    <section class="dp-right">
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>
      <!-- @select="dialogCheck" -->
      <!--列表-->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" @selection-change="handleSelectionChange"
        @row-click="selectCurrentRow" ref="table" class="custom-tbl" height="100%" style="width: 100%">
        <el-table-column type="selection" width="50"> </el-table-column>
        <el-table-column prop="UserId" label="用户ID" width="120">
        </el-table-column>
        <el-table-column prop="UserName" label="用户名称" width="">
        </el-table-column>
        <el-table-column prop="DepartmentName" label="部门" width="">
        </el-table-column>

        <el-table-column prop="DinnerTimeLimitTimes" label="就餐时间段限次" :formatter="formatDinnerTimeLimitTimes"
          width="300px">
        </el-table-column>

        <el-table-column prop="Remarks" label="备注" width="">
        </el-table-column>
        <el-table-column prop="CreateTime" label="创建时间" width="">
        </el-table-column>
      </el-table>
      </div>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="10" :total="total"
          style="float: right">
        </el-pagination>
      </el-col>
      <!--编辑界面-->
      <el-dialog title="编辑限次信息" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false"
        destroy-on-close>
        <el-form :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm" v-if="editFormVisible">

          <el-form-item label="就餐时间段" prop="DinnerTimes">
            <el-select v-model="editForm.DinnerTimes" placeholder="请选择就餐时间段" multiple style="width: 100%"
              @change="updateDinnerTimesChange($event)">
              <el-option v-for="item in dinnerTimeList" :key="item.Id"
                :label="item.DinnerName + '【' + item.StartTime + '-' + item.EndTime + '】'" :value="item.Id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item v-for="(domain, index) in editForm.limitTimes" :label="domain.label + '限次'" :key="domain.key">
            <div style="display: flex;">
              <el-input-number v-model="domain.value" :min="1" :controls="true" :step="1"
                @change="changeVal"></el-input-number>
            </div>
          </el-form-item>

          <el-form-item label="备注">
            <el-input type="textarea" v-model="editForm.Remarks"></el-input>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>

      <!--新增界面-->
      <el-dialog title="新增限次信息" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false"
        destroy-on-close>
        <el-form :model="addForm" label-width="100px" :rules="addFormRules" ref="addForm" class="demo-form-inline"
          v-if="addFormVisible">



          <el-form-item label="就餐时间段" prop="DinnerTimes">
            <el-select v-model="addForm.DinnerTimes" placeholder="请选择就餐时间段" multiple style="width: 100%"
              @change="DinnerTimesChange($event)">
              <el-option v-for="item in dinnerTimeList" :key="item.Id"
                :label="item.DinnerName + '【' + item.StartTime + '-' + item.EndTime + '】'" :value="item.Id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item v-for="(domain, index) in addForm.limitTimes" :label="domain.label + '限次'" :key="domain.key">
            <div style="display: flex;">
              <el-input-number v-model="domain.value" :min="1" :controls="true" :step="1"
                @change="changeVal"></el-input-number>
            </div>
          </el-form-item>

          <el-form-item label="人员" required>
            <div class="ps-pick-summary">
              <span>已选 <strong>{{ personScopeCheckedCount }}</strong> 人
                <template v-if="personScopeDeptCount">（{{ personScopeDeptCount }} 个部门）</template>
              </span>
              <el-button type="primary" size="small" plain @click="openPersonScopeDialog">选择人员</el-button>
              <el-button
                v-if="personScopeCheckedCount"
                type="text"
                size="small"
                @click="clearPersonScopeSelection">
                清空
              </el-button>
            </div>
            <div v-if="personScopeCheckedCount" class="ps-pick-tags">
              <el-tag
                v-for="item in personScopeSelectedPreview"
                :key="item.value"
                size="mini"
                closable
                disable-transitions
                @close="removePersonScopeSelected(item.value)">
                {{ item.label }}
              </el-tag>
              <span v-if="personScopeCheckedCount > 8" class="ps-pick-more">共 {{ personScopeCheckedCount }} 人</span>
            </div>
          </el-form-item>

          <el-form-item label="备注">
            <el-input type="textarea" v-model="addForm.Remarks"></el-input>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

      <!-- 选人：家校/内部通讯录 + 右侧人员表。最后更新：2026-09-15 -->
      <el-dialog
        title="选择人员"
        :visible.sync="personScopeVisible"
        :close-on-click-modal="false"
        append-to-body
        destroy-on-close
        width="1100px"
        top="6vh"
        custom-class="person-scope-dialog"
        @close="onPersonScopeDialogClose">
        <div class="ps-layout" v-loading="personScopeTreeLoading">
          <div class="ps-left">
            <div class="ps-left-header">
              <i class="el-icon-office-building"></i>
              <span>选择机构 / 学校</span>
            </div>
            <div class="ps-scope-bar">
              <button
                type="button"
                class="ps-scope-btn"
                :class="{ 'is-active': personScopeDirectoryScope === 'teaching' }"
                @click="setPersonScopeDirectory('teaching')">
                <i class="el-icon-reading"></i> 家校通讯录
              </button>
              <button
                type="button"
                class="ps-scope-btn"
                :class="{ 'is-active': personScopeDirectoryScope === 'internal' }"
                @click="setPersonScopeDirectory('internal')">
                <i class="el-icon-office-building"></i> 内部通讯录
              </button>
            </div>
            <div class="ps-left-search">
              <el-input
                v-model="personScopeDeptFilter"
                clearable
                size="small"
                prefix-icon="el-icon-search"
                placeholder="输入关键字搜索机构/学校..." />
            </div>
            <div class="ps-left-tree">
              <el-tree
                v-show="personScopeDirectoryScope === 'teaching'"
                ref="personScopeTeachingTree"
                :data="personScopeTeachingTree"
                node-key="value"
                highlight-current
                :expand-on-click-node="false"
                :props="personScopeTreeProps"
                :filter-node-method="filterPersonScopeDeptNode"
                :default-expanded-keys="personScopeTeachingExpandedKeys"
                @node-click="onPersonScopeDeptClick">
                <span class="ps-tree-node" slot-scope="{ node, data }">
                  <span class="ps-tree-node__dot" :class="'tone-' + personScopeNodeTone(data)"></span>
                  <span class="ps-tree-node__label" :title="node.label">{{ node.label }}</span>
                </span>
              </el-tree>
              <el-tree
                v-show="personScopeDirectoryScope === 'internal'"
                ref="personScopeInternalTree"
                :data="personScopeInternalTree"
                node-key="value"
                highlight-current
                :expand-on-click-node="false"
                :props="personScopeTreeProps"
                :filter-node-method="filterPersonScopeDeptNode"
                :default-expanded-keys="personScopeInternalExpandedKeys"
                @node-click="onPersonScopeDeptClick">
                <span class="ps-tree-node" slot-scope="{ node, data }">
                  <span class="ps-tree-node__dot" :class="'tone-' + personScopeNodeTone(data)"></span>
                  <span class="ps-tree-node__label" :title="node.label">{{ node.label }}</span>
                </span>
              </el-tree>
              <div v-if="!personScopeTreeLoading && personScopeCurrentTreeEmpty" class="ps-empty">暂无部门</div>
            </div>
          </div>

          <div class="ps-right">
            <div class="ps-meta">
              已选人员：<strong>{{ personScopeCheckedCount }}</strong> 人
              <span class="ps-meta-sep">·</span>
              涉及部门：<strong>{{ personScopeDeptCount }}</strong> 个
            </div>

            <div class="ps-filter-bar">
              <el-input
                v-model="personScopeNameFilter"
                clearable
                size="small"
                prefix-icon="el-icon-search"
                placeholder="姓名"
                class="ps-name-input"
                @keyup.enter.native="loadPersonScopePeople" />
              <el-button type="primary" size="small" :disabled="!personScopeActiveDeptId" @click="loadPersonScopePeople">
                查询
              </el-button>
              <el-button size="small" :disabled="!personScopeActiveDeptId || !personScopeTableRows.length" @click="selectAllPersonScopeCurrentDept">
                全选当前部门
              </el-button>
              <el-button size="small" :disabled="!personScopeActiveDeptId" @click="clearPersonScopeCurrentDept">
                清空当前部门
              </el-button>
              <el-button size="small" type="text" :disabled="personScopeCheckedCount === 0" @click="clearPersonScopeSelection">
                清空全部已选
              </el-button>
            </div>

            <div class="ps-hint" v-if="personScopeActiveDeptId">
              当前部门：<strong>{{ personScopeActiveDeptName }}</strong>
              <span class="ps-hint-sub">（{{ personScopeDirectoryScope === 'teaching' ? '家校' : '内部' }} · {{ personScopeTableRows.length }} 人）</span>
            </div>
            <div class="ps-hint ps-hint--warn" v-else>请先在左侧选择部门</div>

            <div class="ps-table-wrap" ref="personScopeTableWrap" v-loading="personScopeTableLoading">
              <el-table
                ref="personScopeTable"
                :data="personScopePagedRows"
                row-key="value"
                size="small"
                stripe
                highlight-current-row
                :height="personScopeTableHeight"
                @row-click="onPersonScopeRowClick"
                @selection-change="onPersonScopeTableSelectionChange">
                <el-table-column type="selection" width="46" align="center" />
                <el-table-column prop="label" label="姓名" min-width="120" show-overflow-tooltip />
                <el-table-column label="类型" width="80" align="center">
                  <template slot-scope="scope">
                    <el-tag size="mini" :type="scope.row.personType === 'teacher' ? 'warning' : ''" effect="plain" disable-transitions>
                      {{ scope.row.personType === 'teacher' ? '教职工' : '学生' }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="deptLabel" label="部门" min-width="140" show-overflow-tooltip />
                <el-table-column label="头像" width="72" align="center" header-align="center">
                  <template slot-scope="scope">
                    <oss-media-thumbs
                      v-if="scope.row.HeadPhotoImage"
                      :media="scope.row.HeadPhotoImage"
                      thumb-width="40px"
                      thumb-height="40px"
                    />
                    <span v-else class="ps-avatar-empty">无</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <div class="ps-pager-wrap">
              <el-pagination
                layout="total, prev, pager, next, jumper"
                :page-size="personScopePageSize"
                :total="personScopeTableRows.length"
                :current-page="personScopePage"
                @current-change="handlePersonScopePageChange" />
            </div>

            <div class="ps-actions">
              <el-button @click="personScopeVisible = false">取消</el-button>
              <el-button type="primary" @click="confirmPersonScopeSelection">
                确定（{{ personScopeCheckedCount }}）
              </el-button>
            </div>
          </div>
        </div>
      </el-dialog>

    </section>

  </section>

</template>

<script>
import util from "../../../util/date";
import { testapi } from '../../api/modules/auth';
import { getConsumerLimitTimesUserListPage, getDinnerTimeList, removeConsumerLimitTimesUser, editConsumerLimitTimesUser, addConsumerLimitTimesUser, exportConsumerLimitTimesUser } from '../../api/modules/consumption';
import { getTeachingDepartmentTree, getInternalDepartmentTree } from '../../api/modules/department';
import { BaseApiUrl } from '../../api/base';
import { getStudentSelectList, getTeacherMasterListPage } from '../../api/modules/personnel';
import {
  lockPersonScopeSelectionSync,
  syncPersonScopeElTableSelection,
} from '../../utils/personScopeTableSelection';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import es from "@/lang/es";

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      filters: {
      },
      deptDirectoryScope: 'teaching',
      personScopeVisible: false,
      personScopeTreeLoading: false,
      personScopeTableLoading: false,
      personScopeDirectoryScope: 'teaching',
      personScopeDeptFilter: '',
      personScopeNameFilter: '',
      personScopeTeachingTree: [],
      personScopeInternalTree: [],
      personScopeTeachingExpandedKeys: [],
      personScopeInternalExpandedKeys: [],
      personScopeTreeProps: { label: 'label', children: 'children' },
      personScopeActiveDeptId: '',
      personScopeActiveDeptName: '',
      personScopeTableRows: [],
      personScopePage: 1,
      personScopePageSize: 10,
      personScopeTableHeight: 400,
      personScopeSelectedMap: {},
      personScopeCheckedCount: 0,
      personScopeDeptCount: 0,
      personScopeSyncingTable: false,
      BaseApiUrl: BaseApiUrl, //网络前缀
      searchList: [
        {
          label: '用户名称',
          key: 'name',
        },
      ],
      users: [],
      roles: [],
      options: [],
      total: 0,
      buttonList: [],
      currentRow: null,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      liveTypeList: [],
      liveTypeId: "",
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        DiscountActivityName: [{ required: true, message: "请输入名称", trigger: "blur" }],
        DinnerTimes: [
          { required: true, message: '请选择就餐时间段', trigger: 'change' }
        ],
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        Remarks: "",
        DepartmentId: 0,
        DinnerTimes: [],
        limitTimes: []
      },
      isResouceShow: 0,
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        DiscountActivityName: [{ required: true, message: "请输入名称", trigger: "blur" }],
        DinnerTimes: [
          { required: true, message: '请选择就餐时间段', trigger: 'change' }
        ],
      },
      //新增界面数据
      addForm: {
        Remarks: "",
        DepartmentId: 0,
        DinnerTimes: [],
        UserIds: [],
        limitTimes: []
      },
      DepartmentId: 0,
      currentUserId: '',
      imageUrl: '',
      imageLoadding: false,
      dinnerTimeList: [],
      useType: '0',
      liveTypeList: [],
      liveTypeId: "",
      multipleSelection: []
    };
  },
  computed: {
    personScopeCurrentTreeEmpty() {
      const tree = this.personScopeDirectoryScope === 'internal'
        ? this.personScopeInternalTree
        : this.personScopeTeachingTree;
      return !tree || !tree.length;
    },
    personScopePagedRows() {
      const rows = this.personScopeTableRows || [];
      const size = this.personScopePageSize || 10;
      const page = this.personScopePage || 1;
      return rows.slice((page - 1) * size, page * size);
    },
    personScopeSelectedPreview() {
      return Object.keys(this.personScopeSelectedMap || {})
        .map((k) => this.personScopeSelectedMap[k])
        .slice(0, 8);
    },
  },
  watch: {
    personScopeDeptFilter(val) {
      const tree = this.personScopeDirectoryScope === 'internal'
        ? this.$refs.personScopeInternalTree
        : this.$refs.personScopeTeachingTree;
      if (tree) tree.filter(val);
    }
  },
  beforeDestroy() {
    this.unbindPersonScopeResize();
    clearTimeout(this._treeClickDedupeTimer);
  },
  methods: {
    /** 切换家校 / 内部通讯录树。创建于 2026-09-16 */
    setDeptDirectoryScope(scope) {
      if (scope !== 'teaching' && scope !== 'internal') return;
      if (this.deptDirectoryScope === scope) return;
      this.deptDirectoryScope = scope;
      this.DepartmentId = 0;
      this.users = [];
      this.total = 0;
      this._treeClickDedupeKey = '';
    },
    /** 打开选人弹窗。最后更新：2026-09-15 */
    openPersonScopeDialog() {
      this.personScopeDirectoryScope = 'teaching';
      this.personScopeDeptFilter = '';
      this.personScopeNameFilter = '';
      this.personScopeActiveDeptId = '';
      this.personScopeActiveDeptName = '';
      this.personScopeTableRows = [];
      this.personScopePage = 1;
      this.personScopeVisible = true;
      this.loadPersonScopeDirectoryTrees();
      this.$nextTick(() => this.syncPersonScopeTableHeight());
    },
    onPersonScopeDialogClose() {
      this.unbindPersonScopeResize();
      this.personScopeDeptFilter = '';
      this.personScopeNameFilter = '';
      this.personScopeActiveDeptId = '';
      this.personScopeActiveDeptName = '';
      this.personScopeTableRows = [];
      this.personScopePage = 1;
      this.personScopeTableLoading = false;
    },
    confirmPersonScopeSelection() {
      this.addForm.UserIds = this.collectPersonScopeUserIds();
      this.personScopeVisible = false;
    },
    collectPersonScopeUserIds() {
      return Object.keys(this.personScopeSelectedMap || {}).map((k) => {
        const n = this.personScopeSelectedMap[k];
        return [String(n.deptId), String(n.value)];
      });
    },
    removePersonScopeSelected(userId) {
      const nextMap = Object.assign({}, this.personScopeSelectedMap);
      delete nextMap[String(userId)];
      this.personScopeSelectedMap = nextMap;
      this.refreshPersonScopeSummary();
      this.addForm.UserIds = this.collectPersonScopeUserIds();
    },
    normalizePersonScopeTreeRoot(root) {
      if (!root) return [];
      if (Number(root.value || 0) === 0 && root.children && root.children.length) {
        return root.children;
      }
      return [root];
    },
    firstPersonScopeTreeKey(nodes) {
      if (!nodes || !nodes.length) return '';
      return nodes[0] && nodes[0].value != null ? String(nodes[0].value) : '';
    },
    loadPersonScopeDirectoryTrees() {
      this.personScopeTreeLoading = true;
      const scopeId = this.DepartmentId || 0;
      const p1 = getTeachingDepartmentTree({ pid: 0, scopeDepartmentId: scopeId })
        .then((res) => {
          this.personScopeTeachingTree = this.normalizePersonScopeTreeRoot(res && res.data && res.data.response);
          const key = this.firstPersonScopeTreeKey(this.personScopeTeachingTree);
          this.personScopeTeachingExpandedKeys = key ? [key] : [];
        })
        .catch(() => { this.personScopeTeachingTree = []; });
      const p2 = getInternalDepartmentTree({ pid: 0, scopeDepartmentId: scopeId })
        .then((res) => {
          this.personScopeInternalTree = this.normalizePersonScopeTreeRoot(res && res.data && res.data.response);
          const key = this.firstPersonScopeTreeKey(this.personScopeInternalTree);
          this.personScopeInternalExpandedKeys = key ? [key] : [];
        })
        .catch(() => { this.personScopeInternalTree = []; });
      Promise.all([p1, p2]).finally(() => {
        this.personScopeTreeLoading = false;
        this.$nextTick(() => this.syncPersonScopeTableHeight());
      });
    },
    setPersonScopeDirectory(scope) {
      if (scope !== 'teaching' && scope !== 'internal') return;
      if (this.personScopeDirectoryScope === scope) return;
      this.personScopeDirectoryScope = scope;
      this.personScopeDeptFilter = '';
      this.$nextTick(() => {
        const tree = scope === 'internal'
          ? this.$refs.personScopeInternalTree
          : this.$refs.personScopeTeachingTree;
        if (tree && this.personScopeActiveDeptId) {
          tree.setCurrentKey(this.personScopeActiveDeptId);
        }
      });
    },
    filterPersonScopeDeptNode(value, data) {
      if (!value) return true;
      return (data.label || '').indexOf(value) !== -1;
    },
    personScopeNodeTone(data) {
      if (!data) return 'default';
      const type = (data.DeptOrgType || data.deptOrgType || '').toLowerCase();
      if (type === 'school' || data.IsCompany || data.isCompany) return 'school';
      if (type === 'campus') return 'campus';
      if (type === 'period' || type === 'stage') return 'period';
      if (type === 'grade') return 'grade';
      if (type === 'class') return 'class';
      if (data.BigType === 0 || data.bigType === 0) return 'internal';
      return 'default';
    },
    onPersonScopeDeptClick(data) {
      const id = data && (data.value != null ? data.value : data.Id);
      if (id == null || Number(id) <= 0) {
        this.$message.warning('请选择具体部门');
        return;
      }
      this.personScopeActiveDeptId = String(id);
      this.personScopeActiveDeptName = data.label || data.Name || '';
      this.personScopeNameFilter = '';
      this.personScopePage = 1;
      this.loadPersonScopePeople();
    },
    loadPersonScopePeople() {
      const deptId = this.personScopeActiveDeptId;
      if (!deptId) return;
      this.personScopeTableLoading = true;
      this.personScopePage = 1;
      const name = (this.personScopeNameFilter || '').trim();
      const isTeaching = this.personScopeDirectoryScope === 'teaching';
      const request = isTeaching
        ? getStudentSelectList({ departmentId: deptId, name }).then((res) => {
            const list = (res.data && res.data.response) || [];
            return list.map((s) => ({
              value: String(s.Id),
              label: s.Name || s.StuName || '',
              deptId: String(s.DepartmentId || deptId),
              deptLabel: s.DepartmentName || this.personScopeActiveDeptName,
              scopeDeptId: String(deptId),
              personType: 'student',
              HeadPhotoImage: s.HeadPhotoImage || '',
            }));
          })
        : this.loadAllPersonScopeTeachers(deptId, name);
      request.then((rows) => {
        this.personScopeTableRows = rows || [];
        this.$nextTick(() => {
          this.syncPersonScopeTableHeight();
          this.syncPersonScopeTableSelection();
          this.prefetchPersonScopeAvatars();
        });
      }).catch(() => {
        this.personScopeTableRows = [];
      }).finally(() => {
        this.personScopeTableLoading = false;
      });
    },
    async loadAllPersonScopeTeachers(deptId, name) {
      const pageSize = 500;
      let page = 1;
      let total = 0;
      const all = [];
      do {
        const res = await getTeacherMasterListPage({
          page,
          departmentId: deptId,
          intPageSize: pageSize,
          teacherName: name,
        });
        const pageData = (res.data && res.data.response) || {};
        const list = pageData.data || [];
        total = pageData.dataCount || list.length;
        list.forEach((t) => {
          all.push({
            value: String(t.Id),
            label: t.TeacherName || t.Name || '',
            deptId: String(t.DepartmentId || deptId),
            deptLabel: t.DepartmentName || t.ContextDepartmentName || t.DefaultDepartmentName || this.personScopeActiveDeptName,
            scopeDeptId: String(deptId),
            personType: 'teacher',
            HeadPhotoImage: t.HeadPhotoImage || '',
          });
        });
        if (!list.length || all.length >= total) break;
        page += 1;
      } while (page <= 200);
      return all;
    },
    handlePersonScopePageChange(page) {
      // 先锁住 selection-change，避免翻页时空选清掉当页已选。最后更新：2026-10-29
      lockPersonScopeSelectionSync(this);
      this.personScopePage = page;
      this.$nextTick(() => {
        this.syncPersonScopeTableSelection();
        this.prefetchPersonScopeAvatars();
      });
    },
    prefetchPersonScopeAvatars() {
      const rows = this.personScopePagedRows || [];
      if (!rows.length) return;
      this.prefetchListOssMedia(rows, 'HeadPhotoImage');
    },
    syncPersonScopeTableHeight() {
      const measure = () => {
        const wrap = this.$refs.personScopeTableWrap;
        if (!wrap) return;
        const h = Math.floor(wrap.clientHeight);
        if (h > 120 && h !== this.personScopeTableHeight) {
          this.personScopeTableHeight = h;
          this.$nextTick(() => {
            if (this.$refs.personScopeTable && this.$refs.personScopeTable.doLayout) {
              this.$refs.personScopeTable.doLayout();
            }
          });
        }
      };
      this.$nextTick(() => {
        measure();
        setTimeout(measure, 60);
      });
      this.bindPersonScopeResize();
    },
    bindPersonScopeResize() {
      if (this._personScopeResizeBound) return;
      this._personScopeOnResize = () => this.syncPersonScopeTableHeight();
      window.addEventListener('resize', this._personScopeOnResize);
      this._personScopeResizeBound = true;
    },
    unbindPersonScopeResize() {
      if (this._personScopeOnResize) {
        window.removeEventListener('resize', this._personScopeOnResize);
        this._personScopeOnResize = null;
      }
      this._personScopeResizeBound = false;
    },
    syncPersonScopeTableSelection() {
      syncPersonScopeElTableSelection({
        vm: this,
        tableRef: 'personScopeTable',
        rows: this.personScopePagedRows || [],
        isSelected: (row) => !!this.personScopeSelectedMap[row.value],
      });
    },
    onPersonScopeRowClick(row, column, event) {
      if (event && event.target) {
        const target = event.target;
        if (
          target.classList.contains('el-checkbox__original') ||
          target.classList.contains('el-checkbox__inner') ||
          (target.closest && target.closest('.el-checkbox'))
        ) {
          return;
        }
      }
      const table = this.$refs.personScopeTable;
      if (!table || !row) return;
      table.toggleRowSelection(row);
    },
    onPersonScopeTableSelectionChange(selection) {
      if (this.personScopeSyncingTable) return;
      const selectedIds = {};
      (selection || []).forEach((row) => {
        selectedIds[row.value] = true;
      });
      const nextMap = Object.assign({}, this.personScopeSelectedMap);
      (this.personScopePagedRows || []).forEach((row) => {
        if (selectedIds[row.value]) {
          nextMap[row.value] = {
            value: row.value,
            label: row.label,
            deptId: row.deptId,
            deptLabel: row.deptLabel,
            scopeDeptId: row.scopeDeptId,
            personType: row.personType,
          };
        } else {
          delete nextMap[row.value];
        }
      });
      this.personScopeSelectedMap = nextMap;
      this.refreshPersonScopeSummary();
    },
    selectAllPersonScopeCurrentDept() {
      const people = this.personScopeTableRows || [];
      if (!people.length) return;
      lockPersonScopeSelectionSync(this);
      const nextMap = Object.assign({}, this.personScopeSelectedMap);
      people.forEach((row) => {
        nextMap[row.value] = {
          value: row.value,
          label: row.label,
          deptId: row.deptId,
          deptLabel: row.deptLabel,
          scopeDeptId: row.scopeDeptId,
          personType: row.personType,
        };
      });
      this.personScopeSelectedMap = nextMap;
      this.refreshPersonScopeSummary();
      this.syncPersonScopeTableSelection();
    },
    clearPersonScopeCurrentDept() {
      lockPersonScopeSelectionSync(this);
      const scopeId = String(this.personScopeActiveDeptId || '');
      const nextMap = Object.assign({}, this.personScopeSelectedMap);
      Object.keys(nextMap).forEach((k) => {
        const row = nextMap[k];
        if (String(row.scopeDeptId || row.deptId) === scopeId) delete nextMap[k];
      });
      this.personScopeSelectedMap = nextMap;
      this.refreshPersonScopeSummary();
      this.syncPersonScopeTableSelection();
    },
    clearPersonScopeSelection() {
      lockPersonScopeSelectionSync(this);
      this.personScopeSelectedMap = {};
      this.refreshPersonScopeSummary();
      this.syncPersonScopeTableSelection();
      if (this.addForm) this.addForm.UserIds = [];
    },
    refreshPersonScopeSummary() {
      const list = Object.keys(this.personScopeSelectedMap || {}).map((k) => this.personScopeSelectedMap[k]);
      this.personScopeCheckedCount = list.length;
      const deptSet = {};
      list.forEach((n) => {
        if (n && n.deptId != null) deptSet[String(n.deptId)] = true;
      });
      this.personScopeDeptCount = Object.keys(deptSet).length;
    },

    DinnerTimesChange(value, type) {
      // 先将之前的 limitTimes 项存储在一个临时对象中，方便查找
      const existingLimitTimes = {};
      this.addForm.limitTimes.forEach(item => {
        existingLimitTimes[item.key] = item.value;
      });

      // 清空 limitTimes 数组
      this.addForm.limitTimes = [];

      // 遍历新选择的就餐时间段
      value.forEach(val => {
        const option = this.dinnerTimeList.find(opt => opt.Id === val);
        if (option) {
          // 检查之前是否已经存在对应的 key
          const existingValue = existingLimitTimes[option.Id];
          const newValue = existingValue !== undefined ? existingValue : 1;
          // 添加新的 limitTimes 项
          this.addForm.limitTimes.push({ key: option.Id, label: option.DinnerName, value: newValue });
        }
      });
    },

    updateDinnerTimesChange(value) {
      // 先将之前的 limitTimes 项存储在一个临时对象中，方便查找
      const existingLimitTimes = {};
      this.editForm.limitTimes.forEach(item => {
        existingLimitTimes[item.key] = item.value;
      });

      // 清空 limitTimes 数组
      this.editForm.limitTimes = [];
      // 遍历新选择的就餐时间段
      value.forEach(val => {
        const option = this.dinnerTimeList.find(opt => opt.Id === val);
        if (option) {
          // 检查之前是否已经存在对应的 key
          const existingValue = existingLimitTimes[option.Id];
          const newValue = existingValue !== undefined ? existingValue : 1;
          // 添加新的 limitTimes 项
          this.editForm.limitTimes.push({ key: option.Id, label: option.DinnerName, value: newValue });
        }
      });
    },

    formatDinnerTimeLimitTimes: function (row, column) {
      var arr = JSON.parse(row.DinnerTimeLimitTimes);
      var result = '';
      arr.forEach(function (obj) {
        result += obj.label + '【' + obj.value + '次】' + ' ';
      });
      return result.trim();
    },



    treeNodeClick(data, node, component) {
      const nextId = data && (data.value != null ? data.value : data.Id);
      // 部门树进页默认选中会连发两次，同范围同节点短时去重。最后更新：2026-09-16
      const dedupeKey = `${this.deptDirectoryScope}|${nextId}`;
      if (dedupeKey === this._treeClickDedupeKey) return;
      this._treeClickDedupeKey = dedupeKey;
      clearTimeout(this._treeClickDedupeTimer);
      this._treeClickDedupeTimer = setTimeout(() => {
        this._treeClickDedupeKey = '';
      }, 400);

      this.DepartmentId = nextId;
      this.page = 1;
      this.handleQuery();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },

    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },

    //获取用户列表
    handleQuery() {
      let para = {
        page: this.page,
        departmentId: this.DepartmentId,
        directoryScope: this.deptDirectoryScope,
        ...this.filters,
      }
      this.listLoading = true;

      testapi();
      //NProgress.start();
      getConsumerLimitTimesUserListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
        //NProgress.done();
      });
    },
    //删除
    handleDel() {
      let row = this.multipleSelection
      if (row.length == 0) {
        this.$message({
          message: '请选择要删除的数据！',
          type: 'error',
        })

        return
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          var ids = this.multipleSelection.map((item) => {
            return item.Id
          })
          var b = ids.join(',')
          let para = { ids: b }
          removeConsumerLimitTimesUser(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.handleQuery();
          });
        })
        .catch(() => { });
    },
    //显示编辑界面
    handleEdit() {
      var rows = this.multipleSelection
      if (rows.length == 0 || rows.length > 1) {
        this.$message({
          message: '请选择一行数据进行编辑！',
          type: 'error',
        })
        return
      }
      var row = rows[0];
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
      this.editForm.limitTimes = JSON.parse(this.editForm.DinnerTimeLimitTimes);

      let paraItem = {
        departmentId: row.ParentDepartmentId,
      };

      getDinnerTimeList(paraItem).then((res) => {
        this.dinnerTimeList = res.data.response;
      });

    },
    //显示新增界面
    handleAdd() {
      if (!this.DepartmentId || this.DepartmentId === 0) {
        this.$message({
          message: "请先选择左侧所属机构！",
          type: "warning",
        });
        return;
      }
      this.addFormVisible = true;
      this.addForm = {
        Remarks: "",
        DepartmentId: this.DepartmentId,
        DinnerTimes: [],
        UserIds: [],
        limitTimes: []
      };
      this.clearPersonScopeSelection();

      let para = {
        departmentId: this.DepartmentId,
      };

      getDinnerTimeList(para).then((res) => {
        this.dinnerTimeList = res.data.response;
      });
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);
            editConsumerLimitTimesUser(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.options = [];
                this.editFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.addLoading = false;
                this.editLoading = false;
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      if (!this.personScopeCheckedCount) {
        this.$message({
          message: "请先选择人员",
          type: "warning",
        });
        return;
      }
      this.addForm.UserIds = this.collectPersonScopeUserIds();
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);

            addConsumerLimitTimesUser(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }

              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.clearPersonScopeSelection();
                this.options = [];
                this.addFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.addLoading = false;
              }
            });
          });
        }
      });
    },
    changeVal() {
      this.$forceUpdate()
    },
    /**
     * 导出限次模式用户列表
     */
    async exportExcel() {
      try {
        let para = {
          departmentId: this.DepartmentId,
          directoryScope: this.deptDirectoryScope,
          ...this.filters
        };

        var fileName = "限次模式用户";
        const response = await exportConsumerLimitTimesUser(para);
        if (!response.data) {
          this.$message({
            message: "导出数据为空",
            type: "error",
          });
          return;
        }
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName + '.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error('下载失败:', error);
        this.$message({
          message: "导出失败",
          type: "error",
        });
      }
    },
  },
  mounted() {

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
/* .custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
} */

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 106.8px;
  height: 106.8px;
  line-height: 106.8px;
  text-align: center;
}

.avatar {
  width: 106.8px;
  height: 106.8px;
  display: block;
}

.avatar-uploader-tip {
  position: absolute;
  width: 100%;
  height: 1vw;
  bottom: 20px;
  color: gray;
  z-index: 99;
}
.ps-pick-summary {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  color: #475569;
  font-size: 13px;
}
.ps-pick-tags {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.ps-pick-more {
  color: #94a3b8;
  font-size: 12px;
  line-height: 24px;
}
.ps-layout {
  display: flex;
  gap: 0;
  height: 640px;
  max-height: calc(90vh - 140px);
  min-height: 420px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}
.ps-left {
  width: 300px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #e2e8f0;
  background: #fff;
  min-height: 0;
  overflow: hidden;
}
.ps-left-header {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 12px 14px 8px;
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  flex-shrink: 0;
}
.ps-left-header i { color: var(--btn-primary, #2563eb); }
.ps-scope-bar {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
  padding: 0 12px 10px;
  flex-shrink: 0;
}
.ps-scope-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 32px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #f8fafc;
  color: #64748b;
  font-size: 12px;
  cursor: pointer;
}
.ps-scope-btn.is-active {
  background: #eff6ff;
  border-color: #2563eb;
  color: #1d4ed8;
  font-weight: 600;
}
.ps-left-search { padding: 0 12px 10px; flex-shrink: 0; }
.ps-left-tree {
  flex: 1 1 0;
  min-height: 0;
  height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 0 8px 12px;
  position: relative;
  box-sizing: border-box;
}
.ps-left-tree >>> .el-tree-node__content { height: 34px; border-radius: 6px; }
.ps-left-tree >>> .el-tree-node.is-current > .el-tree-node__content { background: #dbeafe; }
.ps-tree-node {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  width: calc(100% - 24px);
  min-width: 0;
}
.ps-tree-node__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  background: #94a3b8;
}
.ps-tree-node__dot.tone-school { background: var(--btn-primary, #2563eb); }
.ps-tree-node__dot.tone-campus { background: #f59e0b; }
.ps-tree-node__dot.tone-period { background: #8b5cf6; }
.ps-tree-node__dot.tone-grade { background: #06b6d4; }
.ps-tree-node__dot.tone-class { background: #64748b; }
.ps-tree-node__dot.tone-internal { background: #0ea5e9; }
.ps-tree-node__label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #334155;
  font-size: 13px;
}
.ps-empty {
  position: absolute;
  left: 0;
  right: 0;
  top: 40%;
  text-align: center;
  color: #94a3b8;
  font-size: 13px;
}
.ps-right {
  flex: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 12px 16px 14px;
  overflow: hidden;
}
.ps-meta {
  margin-bottom: 10px;
  color: #475569;
  font-size: 13px;
  flex-shrink: 0;
}
.ps-meta-sep { margin: 0 6px; color: #cbd5e1; }
.ps-filter-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  flex-shrink: 0;
}
.ps-name-input { width: 180px; }
.ps-hint {
  font-size: 13px;
  color: #475569;
  margin-bottom: 8px;
  flex-shrink: 0;
}
.ps-hint-sub { color: #64748b; margin-left: 4px; }
.ps-hint--warn { color: #b45309; }
.ps-table-wrap {
  flex: 1 1 0;
  min-height: 0;
  height: 0;
  margin-bottom: 8px;
  overflow: hidden;
}
.ps-table-wrap >>> .el-table__body tr { cursor: pointer; }
.ps-avatar-empty { color: #c0c4cc; font-size: 12px; }
.ps-pager-wrap {
  width: 100%;
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
}
.ps-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  flex-shrink: 0;
}

/* 左侧家校/内部切换。创建于 2026-09-16 */
.dp-left {
  display: flex;
  flex-direction: column;
  min-height: 0;
}
/* 原生 button 必须能收缩，否则撑破 264 侧栏。最后更新：2026-10-30 */
.dept-scope-bar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  padding: 8px 10px 10px;
  border-bottom: 1px solid #f1f5f9;
  background: #f8fafc;
}
.dept-scope-btn {
  flex: 1 1 0;
  min-width: 0;
  max-width: 100%;
  margin: 0;
  padding: 6px 4px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #64748b;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  line-height: 1.25;
  cursor: pointer;
  box-sizing: border-box;
  appearance: none;
  -webkit-appearance: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: border-color .15s ease, color .15s ease, background .15s ease;
}
.dept-scope-btn:hover {
  border-color: #93c5fd;
  color: #2563eb;
}
.dept-scope-btn.is-active {
  border-color: #2563eb;
  background: #eff6ff;
  color: #1d4ed8;
  font-weight: 600;
}
.dp-left >>> .department-pane {
  flex: 1;
  min-height: 0;
}

/* 自定义树节点用 .tree-node__label，长名称换行。最后更新：2026-10-30 */
.dp-left >>> .tree-node__label {
  white-space: normal;
  word-break: break-all;
  line-height: 1.4;
  text-overflow: unset;
  overflow: visible;
}

.dp-left >>> .el-tree-node__content {
  height: auto;
  min-height: 32px;
  padding-top: 4px;
  padding-bottom: 4px;
}

</style>
